import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('uom/index', {params});
    },
    getUom(params) {
        return Service().get('uom/get-uom', {params});
    },
    show(id) {
        return Service().get('uom/show/'+id);
    },
    create(params) {
        return Service().post('uom/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('uom/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('uom/delete/'+id);
    },
}